/** @deprecated */
export enum ImageType {
  BACKGROUND = "background",
  MAIN = "main",
  HERO = "hero",
  HERO_LANDSCAPE = "hero_horizontal",
  THUMBNAIL = "thumbnail",
  THUMBNAIL_FEATURED = "thumbnail_featured",
  HEADER_LANDSCAPE = "header_landscape",
  HEADER_PORTRAIT = "header_portrait",
  PUBLISHER_PROMOTIONAL = "publisher_promotional",
  GAME_HERO = "gamehero",
  EXCLUSIVE_CONTENT = "exclusive_content",
}

export enum ImageKind {
  THUMBNAIL = "thumbnail",
  BACKGROUND = "background",
  BANNER = "banner",
  GAME_HERO = "gamehero",
  LOGO = "logo",
  HERO = "hero",
  HERO_LANDSCAPE = "hero_horizontal",
  THUMBNAIL_FEATURED = "thumbnail_featured",
  PUBLISHER_PROMOTIONAL = "publisher_promotional",
  EXCLUSIVE_CONTENT = "exclusive_content",
}

export enum ImageRatio {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape",
  DEFAULT = "",
}

export interface Image {
  /**
   * MongoId not to be used (internal only)
   */
  id: string;

  /**
   * Image UUID
   */
  uuid: string;

  /** @deprecated */
  type: ImageType;
  /**
   * Image url
   */
  url: string;

  /**
   * If set image theme must match the current theme
   */
  theme?: string;

  /**
   * If brandedOption is set to brandedLight, any text displayed over it must be light also
   * If brandedOption is set to brandedDark, any text displayed over it must be dark also
   */
  brandedOption?: "brandedLight" | "brandedDark";

  /**
   * Image kind
   */
  kind: ImageKind;

  /**
   * Image derivatives (only used on Tizen for the moment)
   */
  derivatives?: Record<string, string>;

  /** Image ratio for portrait landscape */
  ratio?: ImageRatio;
}

/** @deprecated */
export const getImageByThemeName = (
  themeName: string,
  images: Image[],
): Image | undefined => {
  for (const image of images) {
    if (image.theme === themeName) return image;
  }
  // return the first image available
  if (images.length > 0) {
    return images[0];
  }
  return undefined;
};

export const getImageByOrientation = (
  orientation: "PORTRAIT" | "LANDSCAPE",
  images: Image[],
) => {
  const lowerCasedOrientation = orientation.toLocaleLowerCase();
  let img = images.find((im) => im.ratio === lowerCasedOrientation);
  if (!img) {
    img = images.find((im) => !im.ratio);
  }
  if (!img && images.length > 0) {
    img = images[0];
  }
  return img;
};
